import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { PDFPasswordInput as CompiledPDFPasswordInput } from './pdfPasswordInput-compiled';
import { PDFPasswordInput as EmotionPDFPasswordInput } from './pdfPasswordInput-emotion';
export var PDFPasswordInput = function PDFPasswordInput(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledPDFPasswordInput, props) : /*#__PURE__*/React.createElement(EmotionPDFPasswordInput, props);
};